(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOWebapi"), require("VueDemi"), require("FEGORender"), require("FEGOBridge"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOWebapi", "VueDemi", "FEGORender", "FEGOBridge"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-offline-activity-session/render"] = factory(require("FEGOWebapi"), require("VueDemi"), require("FEGORender"), require("FEGOBridge"));
	else
		root["/fego/component/common-offline-activity-session/render"] = factory(root["FEGOWebapi"], root["VueDemi"], root["FEGORender"], root["FEGOBridge"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__7145__) => {
return 